module.exports = __webpack_public_path__ + "img/OsavusTrueGreen.782c9b46.png";